<template>
  <span type="button" :class="classes" @click="passMethod('click')">
    <slot></slot>
  </span>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
};
</script>
